import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { noDefault } from 'lib/eventWrappers';
import { PhoneNumberKindDisplayName, PhoneNumberKinds } from 'server/enums/PhoneNumberKind';
import { PhoneNumber } from './model';
import { MaxLengthTooltip } from 'portcall/pctooltip/view';

// character limit at which tooltips enabled
const MAX_NUMBER_CHARS = 14;

export const PhoneNumberView = SuperCritical(({ model: m } : { model : PhoneNumber }) =>
    <div className="phonenumber">
        <span className="pc-input-viewcontrol pc-text-smalllabel phone-kind">{PhoneNumberKindDisplayName[m.Model.Kind()]}</span>
        <select className="pc-select pc-input-editcontrol pc-text-smalllabel phone-kind"
            value={m.Model.Kind()}
            onChange={e => m.Model.Kind(parseInt((e.target as HTMLSelectElement).value))}>
            {PhoneNumberKinds.map(({ Id, Name }) => 
                <option key={Id} value={Id}>{Name}</option>
            )}
        </select>
        <span className="pc-select-chevron pc-input-editcontrol"></span>
        <MaxLengthTooltip className="pc-input-viewcontrol number-text pc-text-fixedwidth pc-text-fixedwidth-tooltip"
            text={m.Model.Number} maxLength={MAX_NUMBER_CHARS} />
        <input className="pc-input-editcontrol textinput" type="text"
            value={m.Model.Number()}
            onChange={e => m.Model.Number((e.target as HTMLInputElement).value)} />
        <a href="#" className="pc-input-editcontrol" onClick={noDefault(m.Delete)}>
            <i className="pc-close-icon"></i>
        </a>
    </div>
);



// WEBPACK FOOTER //
// ./apps/portcall/phonenumber/view.tsx